import { render, staticRenderFns } from "./CommissionWithdrawal.vue?vue&type=template&id=022145c9&scoped=true"
import script from "./CommissionWithdrawal.vue?vue&type=script&lang=js"
export * from "./CommissionWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./CommissionWithdrawal.vue?vue&type=style&index=0&id=022145c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022145c9",
  null
  
)

export default component.exports